const hostname = window.location.hostname;
let environment = {};
switch (hostname) {
  case 'localhost':
    environment = {
      env: 'local',
      domain: 'https://localhost:3000',
      dataPath: '',
      peopleImgHost: 'https://banner-witcoff.88bp.co',
      linkPath: 'https://banner-witcoff.88bp.co'
    };
    break;
  case 'banner-witcoff.88bp.co':
    environment = {
      env: 'dev',
      domain: 'https://banner-witcoff.88bp.co',
      dataPath: '/wp-content/uploads',
      peopleImgHost: 'https://banner-witcoff.88bp.co',
      linkPath: ''
    };
    break;
  case 'bannerwitcoff.com':
    environment = {
      env: 'prod',
      domain: 'https://bannerwitcoff.com',
      dataPath: '/wp-content/uploads/',
      peopleImgHost: 'https://bannerwitcoff.com',
      linkPath: ''
    };
    break;
  case 'banner.lcl':
    environment = {
      env: 'lcl',
      domain: 'https://banner.lcl',
      dataPath: '/wp-content/uploads/',
      peopleImgHost: 'https://banner.lcl',
      linkPath: ''
    };
    break;
    case '157.245.129.21':
      environment = {
        env: 'prod',
        domain: 'http://157.245.129.21',
        dataPath: '/wp-content/uploads/',
        peopleImgHost: 'http://157.245.129.21',
        linkPath: ''
      };
      break;
  default:
}

export default environment;
